'use strict';

var dateTriggers = require('./dateTriggers');
var validation = require('./validation');

var perimeterx = require('_core_ext/trackers/perimeterx');
var jsonUtil = require('_core_ext/pages/json-util');

var JSConstants = require('_core_ext/pages/tradecard/constants');
var CSSConstants = require('_core_ext/pages/tradecard/cssconstant');

function uploadFiles(files, additionalData) {
    var formData = new FormData();
    var applicationID = additionalData.applicationID,
        customerNo = additionalData.customerNo,
        csrfToken = additionalData.csrfToken;

    if (applicationID && customerNo && csrfToken) {
        formData.append('applicationID', applicationID);
        formData.append('customerNo', customerNo);
        formData.append(Constants.CSRF_TOKEN_NAME, csrfToken);

        for (var i = 0; i < files.length; i++) {
            var file = files[i],
                fileName = file.name;

            formData.append('file' + i, file, (applicationID + '_' + fileName));
        }

        $.ajax({
            type: 'POST',
            url: Urls.uploadFile,
            data: formData,
            processData: false,
            contentType: false
        });
    }
}

function getUploadFiles () {
    var uploaderFiles = window.uploaderFilesCache || [];
    var cameraFiles = [];

    var $cameraInputs = $('input' + JSConstants.CAMERA_INPUT);

    if ($cameraInputs && $cameraInputs.length) {
        var $cameraInput = $cameraInputs[0];

        cameraFiles = $.map($cameraInput.files, function (file) {
            return file;
        });
    }

    return [].concat(uploaderFiles, cameraFiles);
}

function updateDates() {
    dateTriggers.updateBirthday(
        JSConstants.CLASS_BIRTHDAY_DAY, JSConstants.CLASS_BIRTHDAY_MONTH,
        JSConstants.CLASS_BIRTHDAY_YEAR, JSConstants.CLASS_BIRTHDAY
    );

    dateTriggers.updateCourseDate(
        JSConstants.CLASS_COURSE_START_MONTH, JSConstants.CLASS_COURSE_START_YEAR,
        JSConstants.CLASS_COURSE_START, false
    );

    dateTriggers.updateCourseDate(
        JSConstants.CLASS_COURSE_END_MONTH, JSConstants.CLASS_COURSE_END_YEAR,
        JSConstants.CLASS_COURSE_END, true
    );
}

function validateSpecialSteps(stepsToValidate, e) {
    var validateSpecialResult = {};

    for (let i = 0; i < stepsToValidate.length; i++) {
        var $stepValidate = $(CSSConstants.STEPPER + '[data-step="' + stepsToValidate[i] + '"]');
        validateSpecialResult = validation.validateForm(e, $stepValidate, true);

        if (!validateSpecialResult.valid) {
            break;
        }
    }
    return validateSpecialResult;
}

function handleValidation(validateResult, switchTab) {
    var $invalidStepTab = $(JSConstants.STEPPER_TAB + '[data-destination-step="' + validateResult.step + '"]');

    // Switch to invalid tab
    switchTab && $invalidStepTab.trigger('click');

    setTimeout(function() {
        validation.scrollToFirstError(validateResult.fieldsInfo.errorAreas);
    }, 250);
}

function createAccount (callback)  {
    $(document)
        .on('submit', 'form' + JSConstants.REGISTRATION_FORM, function (e) {
            var $form = $(this);
            var isOffline = $form.hasClass(JSConstants.OFFLINE_FORM.substr(1));
            var $submitButton = $form.find('button[type="submit"]');

            // Offline registration handler
            if (isOffline && !$submitButton.is(':disabled')) {
                e.preventDefault();
                updateDates();

                $submitButton.prop('disabled', true);
                // Run validation (offline form - has only 1 step)
                var stepsToValidate = validation.CONSTANT.SPECIAL_STEPS;
                var validateSpecialResult = validateSpecialSteps(stepsToValidate, e);

                if (stepsToValidate.length === 0 || validateSpecialResult.valid) {
                    $form.append('<input type="hidden" name="' + $submitButton.attr('name') + '" />');

                    $.ajax({
                        type: 'POST',
                        url: $form.attr('action'),
                        data: $form.serialize()
                    }).done(function(response) {
                        if (response && typeof response.redirectLink === 'string') {
                            !response.success && $submitButton.prop('disabled', false);
                            window.location.replace(response.redirectLink);
                        }
                    }).fail(function(response) {
                        $submitButton.prop('disabled', false);
                        perimeterx.handleResponce(response);
                    });
                } else {
                    $submitButton.prop('disabled', false);
                    handleValidation(validateSpecialResult, false);
                }
            } else if (!isOffline) {
                e.preventDefault();
            }
        })
        .on('click', JSConstants.SUBMIT_TRADE_FORM, function (e) {
            e.preventDefault();
            updateDates();

            var $form = $(JSConstants.REGISTRATION_FORM);
            var $submitButton = $(e.target);
            $submitButton.prop('disabled', true);

            // Run Special validation
            var stepsToValidate = validation.CONSTANT.SPECIAL_STEPS;
            var validateSpecialResult = validateSpecialSteps(stepsToValidate, e);
            var formData = $form.serialize();
            const copy = [];
            let items = formData.split('&');
            for (let i = 0; i < items.length; i++) {
                if (items[i].indexOf('_customer_professional_companyName') !== -1) {
                    copy.push(i);
                }
            }

            if (copy.length > 1) {
                items.splice(copy[0], 1);
                formData = items.join('&');
            }

            // Online registration handler
            if (stepsToValidate.length === 0 || validateSpecialResult.valid) {
                $.ajax({
                    type: 'POST',
                    dataType: 'html',
                    url: $form.attr('action'),
                    data: formData,
                    headers: {
                        'X-PERIMETER-TYPE': 'json',
                    }
                }).done(function(response) {
                    var $response = $(response);
                    $submitButton.prop('disabled', false);

                    var $jsonData = $response.first();
                    var $confirmationBlock = $response.find(JSConstants.CONFIRMATION_BLOCK);
                    var data = ($jsonData.length && $jsonData.is('div' + JSConstants.CONFIRMATION_JSON))
                        ? jsonUtil.parse($jsonData.text(), {}) : {};

                    if (data && data.success) {
                        if (typeof callback === 'function') {
                            callback(data, $confirmationBlock);
                        }

                        var mergedFiles = getUploadFiles();

                        if (mergedFiles.length > 0) {
                            uploadFiles(mergedFiles, data);
                        }

                    } else {
                        window.location.reload();
                    }
                }).fail(function(response) {
                    perimeterx.handleResponce(response);
                });
            } else {
                $submitButton.prop('disabled', false);
                handleValidation(validateSpecialResult, true);
            }
        })
        .on('click', JSConstants.SUBMIT_UPGRADE_FORM, function (e) {
            e.preventDefault();
            updateDates();

            var $form = $(JSConstants.REGISTRATION_FORM);
            var $submitButton = $(e.target);
            $submitButton.prop('disabled', true);

            // Run Special validation
            var stepsToValidate = validation.CONSTANT.SPECIAL_STEPS;
            var validateSpecialResult = validateSpecialSteps(stepsToValidate, e);

            // Extend & Upgrade registration handler
            if (stepsToValidate.length === 0 || validateSpecialResult.valid) {
                $.ajax({
                    type: 'POST',
                    dataType: 'json',
                    url: $form.attr('action'),
                    data: $form.serialize()
                }).done(function(data) {
                    $submitButton.prop('disabled', false);

                    if (data && data.success) {
                        if (typeof callback === 'function') {
                            callback(data);
                        }

                        var mergedFiles = getUploadFiles();

                        if (mergedFiles.length > 0) {
                            uploadFiles(mergedFiles, data);
                        }

                    } else {
                        window.location.reload();
                    }
                }).fail(function(response) {
                    perimeterx.handleResponce(response);
                });
            } else {
                $submitButton.prop('disabled', false);
                handleValidation(validateSpecialResult, true);
            }
        });
}

module.exports = createAccount;